<!--
* @program: office_automation 
* @author: ly
* @component:QueryFilter 
* @description: 
* @create: 2022-06-17 09:45
-->
<template>
    <a-tooltip title="过滤条件">
        <a-popover trigger="click" placement="bottom">
            <template #content>
                <div>过滤条件：</div>
                <div v-for="(item,index) in filter" :key="index">
                    <a-radio-group class="search-item" v-model:value="fr[index]" @change="radioChange">
                        <a-radio-button v-for="(kk,idx) in item[0]" :value="kk" :key="kk">{{item[1][idx]}}</a-radio-button>
                    </a-radio-group>
                </div>
            </template>
            <a-button  type="link" >
                <template #icon><OrderedListOutlined /></template>
            </a-button>
        </a-popover>
    </a-tooltip>
    <a-tag v-for="item in selectedLabel" :key="item.seg" :color="item.color" closable @close="remove(item)">{{item.label}}</a-tag>
</template>

<script>
    import {OrderedListOutlined} from "@ant-design/icons-vue"
    export default {
        name: "QueryFilter",
        props:["filter","value","disabled"],
        emits:["update:value","change"],
        components:{
            OrderedListOutlined
        },
        computed:{
            selectedLabel(){
                let arr = [];
                for(let i in this.fr){
                    if(this.fr[i]) {
                        let index = this.filter[i][0].indexOf(this.fr[i]);
                        let label = this.filter[i][1][index];
                        let color = this.filter[i][2][index];
                        if(label){
                            arr.push({
                                seg:i,
                                label:label,
                                color:color,
                            })
                        }
                    }
                }
                return arr;
            }
        },
        watch:{
            filter(){
                this.init()
            },
            value(){
                this.fr = {...this.value}
            }
        },
        data() {
            return {
                fr:{},
            }
        },
        methods: {
            init() {
                this.fr = {...this.value};
            },
            radioChange(){
                this.$emit("update:value",this.fr);
                this.$emit("change");
            },
            remove(item){
                delete this.fr[item.seg];
                this.$emit("update:value",this.fr);
                this.$emit("change");
            }
        },
        created() {
            this.init()
        }
    }
</script>

<style scoped>

</style>